export default __webpack_public_path__ + "static/media/slide_7.5c1c5f23.jpg";